import React, { Component } from 'react';
import { Modal, Radio, message, Spin, Input } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const RadioGroup = Radio.Group;

class ApproveVitaeModal extends Component {
    state = {
        visible: false,
        loading: false,
        fileId: '',
        approvalStatus: '',
        refuseReason: '',
    }

    show = (id) => {
        this.setState({
            visible: true,
            fileId: id,
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            approvalStatus: '',
        });
    }

    submit = () => {
        const {
            fileId,
            approvalStatus,
            refuseReason,
        } = this.state;
        if (!approvalStatus) {
            message.warning('请选择审批是否通过');
            return;
        }
        if (approvalStatus == 'REJECT' && !refuseReason) {
            message.warning('请输入审批不通过原因');
            return;
        }
    
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.folder.approveVitae,
            data: {
                fileId,
                approvalStatus,
                refuseReason,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.queryTableData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleChange = (e) => {
        this.setState({ approvalStatus: e.target.value });
    }

    handleInputChange = (e) => {
        this.setState({ refuseReason: e.target.value });
    }

    render() {
        const { visible, loading, approvalStatus, refuseReason } = this.state;
        return (
            <Modal
                title={''}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="480px"
                bodyStyle={{ minHeight: 120 }}
            >
                <Spin spinning={loading}>
                    <div style={{ padding: '15px 30px' }}>
                        <div style={{ padding: '10px', fontSize: '20px', fontWeight: 900 }}>是否审批通过</div>
                        <RadioGroup 
                            style={{ padding: '10px 30px' }}
                            value={approvalStatus}
                            onChange={e => this.handleChange(e)} 
                        >
                            <Radio value='AGREE' style={{ marginRight: 50 }}>审批通过</Radio>
                            <Radio value='REJECT'>审批不通过</Radio>
                        </RadioGroup>
                    </div>
                    {
                        approvalStatus == 'REJECT' && 
                            <div style={{ padding: '0px 80px 15px' }}>
                                <Input 
                                    placeholder='请输入不通过原因'
                                    style={{ width: 220 }}
                                    value={refuseReason}
                                    onChange={e => this.handleInputChange(e)} 
                                />
                            </div>
                    }
                </Spin>
            </Modal>
        )
    }
}

export default ApproveVitaeModal;


// WEBPACK FOOTER //
// ./src/components/personal/file/ApproveVitaeModal.js